<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <div
        v-if="showDiagnostics"
        id="diagnostics"
    >
        <v-expand-transition>
            <v-card width="500">
                <v-list-item
                    two-line
                    class="header"
                    sticky
                >
                    <v-container class="pa-0">
                        <v-row align="center">
                            <v-col
                                class="py-0 pl-4 pr-0"
                                :md="9"
                                :cols="8"
                            >
                                <v-list-item-title class="text-h6 d-flex">
                                    <v-icon @click="menuIconClick()">mdi-menu</v-icon>
                                    <span class="pl-2 text-truncate">Diagnostics</span>
                                </v-list-item-title>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-list-item>
                <v-list-item v-if="!loading.finishedCombining">
                    <v-file-input
                        v-model="datalogsArray"
                        placeholder="datalog mergen"
                        label="datalog mergen"
                        prepend-icon="mdi-paperclip"
                        multiple
                    >
                    </v-file-input>
                </v-list-item>
                <!-- <v-list-item v-if="!loading.finishedCombining">
                    <v-file-input
                        v-model="datalog"
                        placeholder="datalog"
                        label="datalog"
                        prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                </v-list-item> -->
                <v-list-item v-if="!loading.finishedCombining">
                    <v-file-input
                        v-model="lidarlog"
                        placeholder="lidarlog"
                        label="lidarlog"
                        prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                </v-list-item>
                <v-list-item>
                    <ProjectionSelect v-model="projection" />
                </v-list-item>
                <v-alert
                    v-if="error"
                    type="error"
                >
                    {{ errorMessage }}
                </v-alert>
                <v-list-item v-if="datalogsArray.length > 0 && lidarlog && projection && !loading.finishedCombining">
                    <v-btn
                        :loading="loading.loading"
                        @click="parseFiles()"
                    >parse</v-btn>
                </v-list-item>

                <v-list-item v-if="datalogsArray.length > 0">
                    <v-btn
                        :loading="loading.loading"
                        @click="mergeFiles(true)"
                    >merge</v-btn>
                </v-list-item>

                <v-list-item v-if="loading.finishedCombining">
                    <v-slider
                        v-model="selectedLog"
                        class="align-center"
                        :max="parsedDatalog.data.length - 1"
                        :min="0"
                        hide-details
                    >
                        <template v-slot:append>
                            <v-text-field
                                v-model="selectedLog"
                                hide-details
                                single-line
                                density="compact"
                                type="number"
                                style="width: 70px"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-list-item>
                <v-list-item v-if="loading.finishedCombining">
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(-100)"
                    >-100</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(-10)"
                    >-10</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(-1)"
                    >-1</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog()"
                    >draw</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(+1)"
                    >+1</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(10)"
                    >+10</v-btn>
                    <v-btn
                        :loading="loading.loading"
                        @click="drawDatalog(100)"
                    >+100</v-btn>
                </v-list-item>
                <v-card-actions>
                    <v-btn @click="clear()">clear</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDiagnostics">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
    </div>
</template>
  
<script>
import ProjectionSelect from "./formfields/ProjectionSelect";
import Datalog from "../models/Datalog"
import Lidarlog from "../models/Lidarlog"

export default {
    components: {
        ProjectionSelect
    },
    props: {
        /* Map.vue reference */
        map: {
            required: true,
        },
    },
    data() {
        return {
            showDiagnostics: false,
            datalog: null,
            lidarlog: null,
            datalogsArray: [],
            error: false,
            errorMessage: "",


            lineIndex: 0,
            loading: {
                loading: false,
                finishedDatalog: false,
                finishedLidarlog: false,
                finishedCombining: false,
            },

            projection: "",
            selectedLog: 0,
        };
    },
    mounted: function () {
        this.parsedDatalog = null;
        this.parsedLidarlog = null;
    },
    computed: {
    },
    watch: {
        loading: {
            handler(val) {
                if (val.finishedDatalog && val.finishedLidarlog && !val.finishedCombining && !this.error) {
                    console.log("done reading");
                    this.addFileNamesToLines();
                }

            },
            deep: true,
        },
    },
    methods: {
        mergeFiles(download) {
            console.log(this.datalogsArray);

            this.readFileArray(this.datalogsArray, this.parseFileArray, download);

        },
        //recursive function for reading files, with callback function for parsing file array
        readFileArray(fileArray, callback = null, downloadFile = false, fileIndex = 0, readFileArray = []) {
            if (fileIndex < fileArray.length) {
                // read the next file
                const fr = new FileReader();
                fr.readAsText(fileArray[fileIndex]);
                fr.addEventListener('load', (e) => {
                    readFileArray.push(e.target.result);
                    this.readFileArray(fileArray, callback, downloadFile, fileIndex + 1, readFileArray);
                })
            }
            else {
                // callback function
                callback(readFileArray, downloadFile)
            }
        },
        parseFileArray(readFileArray, downloadFile) {
            this.parsedDatalog = new Datalog(readFileArray);
            this.loading.finishedDatalog = true;

            if (downloadFile) {
                var datalogString = this.parsedDatalog.getDatalogString()
                // console.log(datalogString);

                // new File([new Blob([datalogString])], "datalog.csv");

                var fileURL = window.URL.createObjectURL(new Blob([datalogString]));
                var fileLink = document.createElement("a");

                fileLink.href = fileURL;
                // TODO: better filename
                fileLink.setAttribute("download", "datalog.csv");
                document.body.appendChild(fileLink);

                fileLink.click();

            }
        },
        parseFiles() {
            this.mergeFiles();

            this.loading.loading = true;
            var lidarlogReader = new FileReader();
            lidarlogReader.onload = function (e) {
                var contents = e.target.result;
                try {
                    this.parsedLidarlog = new Lidarlog(contents);
                    this.loading.finishedLidarlog = true;
                } catch (error) {
                    console.error(error)
                    this.error = true;
                    this.errorMessage = "er ging iets mis bij het uitlezen van de lidar log, controleer het bestand."
                    this.loading.loading = false;
                }
            }.bind(this);

            try {
                lidarlogReader.readAsText(this.lidarlog);
            } catch (error) {
                console.error(error)
                this.error = true;
                this.errorMessage = "er ging iets mis bij het uitlezen van de lidar log, controleer het bestand."
                this.loading.loading = false;
            }
        },
        toggleDiagnostics() {
            this.showDiagnostics = !this.showDiagnostics;
        },
        menuIconClick() {
            this.$emit("menuListClick");
        },
        addFileNamesToLines() {
            try {
                this.checkFirstFileName()

                var lidarlogsAdded = 1
                for (let i = 0; i < this.parsedLidarlog.data.length; i++) {
                    while (this.parsedDatalog.data.length > this.lineIndex && this.parsedLidarlog.data[i + 1].Timestamp > this.parsedDatalog.data[this.lineIndex].EndCalcClock) {
                        if (lidarlogsAdded <= 20) // check if lidarlogs ar not too old (20 lines is 1 second)
                            this.parsedDatalog.data[this.lineIndex].setLidarLog(this.parsedLidarlog.data[i]);
                        this.lineIndex++;
                        lidarlogsAdded++;
                    }
                    console.log('next lidar log found at: ' + (this.lineIndex + 1))
                    lidarlogsAdded = 0;
                    i++
                }
                this.loading.loading = false;
                this.loading.finishedCombining = true;
                console.log(this.parsedDatalog)
                this.drawDatalog()
            } catch (error) {
                console.error(error)
                this.error = true;
                this.errorMessage = "er ging iets mis bij het samenvoegen van de logs, controleer de bestanden."
                this.loading = {
                    loading: false,
                    finishedDatalog: false,
                    finishedLidarlog: false,
                    finishedCombining: false,
                }
            }
        },
        checkFirstFileName() {
            for (let i = 0; i < this.parsedDatalog.data.length; i++) {
                if (this.parsedDatalog.data[i].EndCalcClock >= this.parsedLidarlog.data[0].Timestamp) {
                    console.log('found lidar log at line: ' + (i + 1));
                    this.parsedDatalog.data[i].setLidarLog(this.parsedLidarlog.data[0]);
                    this.lineIndex = i;
                    return;
                }
            }
            console.log("no connected lidarlogs found")
            this.lineIndex = this.parsedDatalog.data.length;
        },
        drawDatalog(step = 0) {
            this.selectedLog += step;
            if (this.selectedLog < 0)
                this.selectedLog = 0;
            if (this.selectedLog > (this.parsedDatalog.data.length - 1))
                this.selectedLog = this.parsedDatalog.data.length - 1;
            this.map.drawAdminDiagnostics(this.parsedDatalog.data[this.selectedLog], this.projection, step === 0);
        },
        closeDiagnostics() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.parsedDatalog = null;
            this.parsedLidarlog = null;
            this.map.clearAdminDiagnostics();
        },
        clear() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.parsedDatalog = null;
            this.parsedLidarlog = null;
            this.map.clearAdminDiagnostics();
            this.showDiagnostics = true;
        }
    },
};
</script>
  
<style scoped>
#diagnostics {
    z-index: 80;
    margin-left: 5px;
    position: absolute;
    top: 6px;
    left: 2px;
}
</style>
  